// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player_root__1wZHa {\n  width: 100%;\n  position: relative; }\n", ""]);
// Exports
exports.locals = {
	"root": "player_root__1wZHa"
};
module.exports = exports;
